/**
 * Helpers purs pour l'édition du layout du tableau cash-flow
 * (ordre des catégories racines + soldes intermédiaires).
 */

function categoryRow(node, position) {
  return {
    id:          node.id,
    position,
    kind:        'category',
    category_id: node.id,
    label:       null,
  };
}

/**
 * Layout éditable = layout sauvegardé (copie) + toutes les catégories racines
 * qui n'y figurent pas encore, ajoutées à la fin. Sans ça, une catégorie créée
 * après la dernière sauvegarde reste coincée hors du layout, sans possibilité
 * de la déplacer.
 *
 * @param {Array} savedLayout  rows telles que renvoyées par GET /cash-flow/layout
 * @param {Array} tree         racines de l'arbre catégories (ordre par défaut)
 * @returns {Array}
 */
export function buildEditableLayout(savedLayout, tree) {
  const rows = (savedLayout ?? []).map((r) => ({ ...r }));
  const placed = new Set(rows.filter((r) => r.kind === 'category').map((r) => r.category_id));
  for (const node of tree) {
    if (!placed.has(node.id)) rows.push(categoryRow(node, rows.length));
  }
  return rows.map((r, i) => ({ ...r, position: i }));
}

/**
 * Déplace la ligne `rowId` de `delta` crans (-1 = monter, +1 = descendre).
 * Renvoie le tableau d'origine (même référence) si le déplacement est impossible.
 *
 * @param {Array}  layout
 * @param {string} rowId
 * @param {number} delta
 * @returns {Array}
 */
export function moveLayoutRow(layout, rowId, delta) {
  const from = layout.findIndex((r) => r.id === rowId);
  if (from === -1) return layout;
  const to = from + delta;
  if (to < 0 || to >= layout.length) return layout;
  const next = layout.slice();
  const [row] = next.splice(from, 1);
  next.splice(to, 0, row);
  return next;
}
